(function (Drupal) {
  Drupal.behaviors.accordions = {
    attach: function (context, drupalSettings) {
      once('accordionToggle', '.accordion', context).forEach(element => {
        element.querySelector('button').addEventListener('click', event => {
          event.preventDefault()
          element.classList.toggle('accordion--open');
          element.classList.toggle('accordion--closed');
        })
      })
    }
  }
})(Drupal);
